import gql from 'graphql-tag';

export default gql`
  query assignedAgentsQuery($networkID: String!, $priceTierID: String!) {
    assignedAgents(networkID: $networkID, priceTierID: $priceTierID)
  }
`;
